const routers = [
  {
    path: '/',
    meta: {
      title: '帮助中心'
    },
    component: (resolve) => require(['./views/docList.vue'], resolve)
  },
  {
    path: '/docList',
    meta: {
      title: '帮助中心'
    },
    component: (resolve) => require(['./views/docList.vue'], resolve)
  },
  {
    path: '/docDetail/:cid/:id',
    meta: {
      title: '帮助中心详情'
    },
    component: (resolve) => require(['./views/docDetail.vue'], resolve)
  },
  {
    path: '/videoList',
    meta: {
      title: '操作教程'
    },
    component: (resolve) => require(['./views/videoList.vue'], resolve)
  },
  {
    path: '/videoDetail/:cid/:id',
    meta: {
      title: '操作教程详情'
    },
    component: (resolve) => require(['./views/videoDetail.vue'], resolve)
  },
  {
    path: '/studyList',
    meta: {
      title: '管理学院'
    },
    component: (resolve) => require(['./views/studyList.vue'], resolve)
  },
  {
    path: '/studyCateDetail/:cid',
    meta: {
      title: '分类管理详情'
    },
    component: (resolve) => require(['./views/studyDetail.vue'], resolve)
  },
  {
    path: '/studyDetail/:cid/:id',
    meta: {
      title: '管理详情'
    },
    component: (resolve) => require(['./views/studyDetail.vue'], resolve)
  },
  {
    path: '/logList',
    meta: {
      title: '更新日志'
    },
    component: (resolve) => require(['./views/logList.vue'], resolve)
  }
]
export default routers



// WEBPACK FOOTER //
// ./src/router.js